<template>
  <div>
    <div class="search-input-wrap">
      <input type="text" class="form-control" :placeholder="$t('ui.search')" v-model.trim="searchCargo" ref="search"
             @keypress.13.prevent="removeFocus()">
      <span v-if="searchCargo" @click="searchCargo = ''">
              <i class="far fa-times"/>
      </span>
    </div>
    <transition-group name="top" appear>
      <cargo :key="idx+1" v-for="(cargo,idx) in cargoBySearch"
             v-show="(cargo.orderIds && cargo.orderIds.length)" :cargo="cargo"/>
    </transition-group>
  </div>
</template>


<script>
import {mapGetters} from 'vuex';
import Cargo from '../../components/loading/Cargo';


export default {
  components: {
    Cargo
  },
  data() {
    return {
      searchCargo: '',
      previousBarcode: null,
      beingProcessed: false
    };
  },
  computed: {
    ...mapGetters(['getAPICompanyID']),
    ...mapGetters('cargo', ['getCargos']),
    cargoBySearch() {
      let cargos = this.getCargos;

      return cargos.filter((search) => {
        if (search && search.reference.length >= 0) {
          if (this.getAPICompanyID == 7 || this.getAPICompanyID == 1) {
            let differenceInHours = moment().diff(search.estimatedTimeOfDeparture.toDate(), 'hours')
            return search.reference.toLowerCase().indexOf(this.searchCargo.toLowerCase()) >= 0 && differenceInHours < 10;
          } else {

            return search.reference.toLowerCase().indexOf(this.searchCargo.toLowerCase()) >= 0
                && !search.finished
                && search.status !== 'done';
          }
        }
      }).sort((a, b) => {
        // Order = the order of the states should be sorted. So 'done' to the bottom.
        let order = ['loading', 'waiting', 'done'];
        if (order.indexOf(a.status) < order.indexOf(b.status)) {
          return -1;
        }
        if (order.indexOf(a.status) > order.indexOf(b.status)) {
          return 1;
        }
        return 0;
      }).sort((a, b) => {
        // If finished => move to the bottom.
        if (b.finished) {
          return -1;
        }
        return 0;
      });
    }
  },
  methods: {
    removeFocus() {
      this.$refs.search.blur();
    }
  },

  async beforeRouteLeave(from, to, next) {
    await this.$store.dispatch('resetStoreModules', ['outgoingCargoProgress','deviations']);
    next();

  },
  created() {
    this.$store.dispatch('initDataForPage', [{
      module: 'outgoingCargoProgress',
      where: ['estimatedTimeOfDeparture', '>=', moment().subtract(5, 'day').toDate()]
    }]);
  }
};
</script>
